import React from 'react';
import AppLogo from '@/components/ui/AppLogo';

const stats = [
  { value: '400+', label: 'Seniors Photographed' },
  { value: '3', label: 'Outfit Packages' },
  { value: '48hr', label: 'Reminder Lead Time' },
];

export default function BrandPanel() {
  return (
    <div className="hidden lg:flex lg:w-[480px] xl:w-[540px] 2xl:w-[600px] flex-col justify-between bg-[#1a1a2e] px-12 py-14 relative overflow-hidden">
      {/* Decorative circles */}
      <div className="absolute top-[-80px] right-[-80px] w-64 h-64 rounded-full border border-[#c9a96e]/10" />
      <div className="absolute top-[-40px] right-[-40px] w-40 h-40 rounded-full border border-[#c9a96e]/15" />
      <div className="absolute bottom-[-60px] left-[-60px] w-48 h-48 rounded-full border border-[#c9a96e]/10" />
      {/* Logo */}
      <div className="flex items-center gap-3 relative z-10">
        <AppLogo size={36} />
        <span className="font-display text-2xl text-white tracking-tight">SeniorShots</span>
      </div>
      {/* Center content */}
      <div className="relative z-10">
        <div className="w-16 h-px bg-[#c9a96e] mb-8" />
        <h1 className="font-display text-4xl xl:text-5xl text-white leading-tight mb-5">
          Your senior year,{' '}
          <span className="text-[#c9a96e] italic">beautifully</span>{' '}
          captured.
        </h1>
        <p className="text-gray-400 text-base leading-relaxed mb-10 max-w-sm">
          Book your portrait session in minutes. Choose your package, pick your
          perfect time slot, and leave the rest to us.
        </p>

        {/* Stats row */}
        <div className="flex gap-8">
          {stats?.map((s) => (
            <div key={`stat-${s?.label}`}>
              <p className="text-[#c9a96e] text-2xl font-bold tabular-nums">{s?.value}</p>
              <p className="text-gray-500 text-xs mt-0.5">{s?.label}</p>
            </div>
          ))}
        </div>
      </div>
      {/* Testimonial */}
      <div className="relative z-10 bg-white/5 border border-white/10 rounded-xl p-5">
        <p className="text-gray-300 text-sm leading-relaxed italic mb-3">
          &ldquo;The booking was so easy — I picked my time, chose my outfits, and
          signed everything online. My photos turned out amazing.&rdquo;
        </p>
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-[#c9a96e]/20 flex items-center justify-center text-[#c9a96e] text-xs font-semibold">
            MK
          </div>
          <div>
            <p className="text-white text-xs font-medium">Maya Krishnamurthy</p>
            <p className="text-gray-500 text-xs">Class of 2025</p>
          </div>
        </div>
      </div>
    </div>
  );
}